import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const tutorApi = createApi({
  reducerPath: 'tutorApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getTutors: builder.query({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params.pageNumber) searchParams.append("pageNumber", params.pageNumber);
        if (params.take) searchParams.append("take", params.take);
        if (params.search) searchParams.append("search", params.search);
        if (params.language) searchParams.append("language", params.language);

        if (params.times?.length) {
          params.times.forEach((t) => searchParams.append("times", t));
        }
        if (params.days?.length) {
          params.days.forEach((d) => searchParams.append("days", d));
        }

        return `/WebAuth/GetAllTutorsByStudent?${searchParams.toString()}`;
      },
    }),
    getTutor: builder.query({
      query: ({Id}) => ({
        url: `/WebAuth/GetTutorByStudent`,
        method: "Get",
        params: {Id}
      }),
    }),
    getTutorsByIds: builder.query({
      query: (ids) => {
        const params = ids.map((id) => `ids=${id}`).join('&');
        return `/WebTutor/GetTutorsByIds?${params}`;
      },
    }),
    getStudentsByIds: builder.query({
      query: (ids) => {
        const params = ids.map((id) => `ids=${id}`).join('&');
        return `/WebAuth/GetStudentsByIds?${params}`;
      },
    }),
  }),
});

export const { 
  useGetTutorsQuery,
  useGetTutorQuery,
  useGetTutorsByIdsQuery,
  useGetStudentsByIdsQuery,
} = tutorApi;